import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { TextFormField } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/TextFormField';
import { UpdateArrearsForm } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutContent';
import { TextFormFieldError } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/TextFormFieldError';

export const ArrearsFlyoutInstitutionNumberField = ({
  isReadOnly,
  form
}: {
  isReadOnly: boolean;
  form: UseFormReturn<UpdateArrearsForm>;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  const rules = {
    required: t('arrearsFlyout.errors.institutionNumber.required'),
    pattern: {
      value: /^\d{3}$/,
      message: t('arrearsFlyout.errors.institutionNumber.pattern')
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="8px" flex="1">
      <Body size={'smallBold'}>{t('arrearsFlyout.institutionNumber')}</Body>
      <Controller
        name="institutionNumber"
        control={form.control}
        rules={rules}
        render={({ field }) => (
          <TextFormField
            name={field.name}
            value={field.value}
            onBlur={field.onBlur}
            onChange={field.onChange}
            disabled={isReadOnly}
            inputProps={{
              'aria-label': t('arrearsFlyout.institutionNumber')
            }}
            error={!!form.formState.errors.institutionNumber}
            helperText={
              <TextFormFieldError error={form.formState.errors.institutionNumber?.message} />
            }
            showClearButton={form.getValues(field.name) !== ''}
            onClear={async () => {
              form.setValue(field.name, '', { shouldValidate: true });
            }}
          />
        )}
      />
    </Box>
  );
};
